import { Feedback as AntdFeedback } from "@empglabs/backoffice-ui-kit"

const Feedback = props => {
  return <AntdFeedback {...props} />
}

export default Feedback
